import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { SiteProvider } from "@/lib/site";
import Landing from "@/pages/Landing";
import Shop from "@/pages/Shop";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLayout from "@/pages/admin/AdminLayout";
import Account from "@/pages/Account";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App">
        <div className="grain" aria-hidden />
        <Toaster theme="dark" position="bottom-right" richColors />
        <BrowserRouter>
          <AuthProvider>
            <SiteProvider>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/account" element={<Account />} />
                <Route path="/admin/*" element={<AdminLayout />} />
              </Routes>
            </SiteProvider>
          </AuthProvider>
        </BrowserRouter>
      </div>
    </ReactLenis>
  );
}

export default App;
